export default [
  {
    path: '/project/:alias/:projectAlias/setting/approver',
    name: 'page-merge-request-rules',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('./pages/page-merge-request-approver-placeholder')
  }
];
